import {
  usePollBonusService,
  usePollUserService,
  usePollLobbyDataService,
} from "@shared/hooks/uses-services";
import { memo } from "react";

export const PollerComponent = memo(() => {
  usePollBonusService();
  usePollUserService();
  usePollLobbyDataService();

  return null;
});

PollerComponent.displayName = "Poller";
